import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'start', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  { path: 'home/:projectName', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  { path: 'start/:token/:projectId', loadChildren: () => import('./start/start.module').then( m => m.StartPageModule)},
  {
    path: 'telnum',
    loadChildren: () => import('./telnum/telnum.module').then( m => m.TelnumPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login/:projectName',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'code',
    loadChildren: () => import('./code/code.module').then( m => m.CodePageModule)
  },
  {
    path: 'start',
    loadChildren: () => import('./start/start.module').then( m => m.StartPageModule)
  },
  {
    path: 'maps',
    loadChildren: () => import('./maps/maps.module').then( m => m.MapsPageModule)
  },
  {
    path: 'atlas',
    loadChildren: () => import('./atlas/atlas.module').then( m => m.AtlasPageModule)
  },
  {
    path: 'species-reporting',
    loadChildren: () => import('./species-reporting/species-reporting.module').then( m => m.SpeciesReportingPageModule)
  },
  {
    path: 'my-reports',
    loadChildren: () => import('./my-reports/my-reports.module').then( m => m.MyReportsPageModule)
  },
  {
    path: 'change-telnum',
    loadChildren: () => import('./change-telnum/change-telnum.module').then( m => m.ChangeTelnumPageModule)
  },
  {
    path: 'update-profile',
    loadChildren: () => import('./update-profile/update-profile.module').then( m => m.UpdateProfilePageModule)
  },
  {
    path: 'credits',
    loadChildren: () => import('./credits/credits.module').then( m => m.CreditsPageModule)
  },
  {
    path: 'atlas-type/:type_id',
    loadChildren: () => import('./atlas-type/atlas-type.module').then( m => m.AtlasTypePageModule)
  },
  {
    path: 'atlas-specie/:species_id',
    loadChildren: () => import('./atlas-specie/atlas-specie.module').then( m => m.AtlasSpeciePageModule)
  },
  {
    path: 'species-reporting-type/:type_id',
    loadChildren: () => import('./species-reporting-type/species-reporting-type.module').then( m => m.SpeciesReportingTypePageModule)
  },
  {
    path: 'species-reporting-specie/:type_id/:species_id',
    loadChildren: () => import('./species-reporting-specie/species-reporting-specie.module').then( m => m.SpeciesReportingSpeciePageModule)
  },
  {
    path: 'species-reporting-specie/:draft_id',
    loadChildren: () => import('./species-reporting-specie/species-reporting-specie.module').then( m => m.SpeciesReportingSpeciePageModule)
  },
  {
    path: 'maps-result',
    loadChildren: () => import('./maps-result/maps-result.module').then( m => m.MapsResultPageModule)
  },
  {
    path: 'image-gallery',
    loadChildren: () => import('./image-gallery/image-gallery.module').then( m => m.ImageGalleryPageModule)
  },
  {
    path: 'reports-view/:id',
    loadChildren: () => import('./reports-view/reports-view.module').then( m => m.MyReportsViewPageModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./info/info.module').then( m => m.InfoPageModule)
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then( m => m.ProjectsPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
